import { createFileRoute } from "@tanstack/react-router";
import { redirectIntoScope } from "@/app/router/legacy-redirect";

/** Old unscoped URL: `/appointments/…` → `/{store}/appointments/…`. */
export const Route = createFileRoute("/appointments/$")({ beforeLoad: redirectIntoScope });
